import { Environment, Mode } from '../config/general.config.js';

export enum ServerStatus {
	Unknown,
	OK,
	Unhealthy,
}

export class HealthStatus {
	public status = ServerStatus.Unknown;
	public indexDocCount: number;
	public apiVersion: string;
	public environment: Environment;
	public message: string;
	public warnings: string[];
	public dataLake: string;
	public masterData: string;
	public database: string;
	public dbConnected: boolean;
	public dbViewUser: string;
	public dbPersistenceUser: string;
	public dbMasterDataUser: string;
	public viewStatuses: Record<string, boolean>;
	public lastIndex: number;
	public mode: Mode;
}
